class SortCustomSelect extends HTMLElement {
  constructor() {
    super();
    this.selectButton = this.querySelector('.js-select-button');
    this.buttonLabel = this.selectButton.querySelector('.js-button-label');
    this.selectDropdown = document.querySelector('.js-select-dropdown');
    this.selectItems = document.querySelectorAll('.js-select-item');
    this.hiddenSelect = document.querySelector('.js-hidden-select');
  }

  connectedCallback() {
    // Select the first option if none is selected
    if (!this.buttonLabel.textContent) {
      const firstOption = this.hiddenSelect.options[0];
      this.hiddenSelect.value = firstOption.value;
      this.buttonLabel.textContent = firstOption.textContent;

      const event = new CustomEvent('customInput', {
        detail: {
          name: this.hiddenSelect.value,
        },
        bubbles: true,
        composed: true
      });
      this.hiddenSelect.dispatchEvent(event);
    }

    // Toggle dropdown visibility
    this.selectButton.addEventListener('click', () =>
      this.selectButton.classList.toggle('open')
    );

    // Handle item selection
    this.selectItems.forEach((item) => {
      item.addEventListener('click', () => {
        this.buttonLabel.textContent = item.textContent;
        this.hiddenSelect.value = item.dataset.value;

        // Trigger input event so Shopify's sorting still works
        const event = new CustomEvent('customInput', {
          detail: {
            name: this.hiddenSelect.value,
          },
          bubbles: true,
          composed: true
        });
        this.hiddenSelect.dispatchEvent(event);

        this.selectButton.classList.remove('open');
      });
    });

    // Close dropdown when clicking outside
    document.addEventListener('click', (e) => {
      if (
        !this.selectButton.contains(e.target) &&
        !this.selectDropdown.contains(e.target)
      ) {
        this.selectButton.classList.remove('open');
      }
    });
  }
}

customElements.define('sort-custom-select', SortCustomSelect);
